import React, { useState, useRef } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setStatus('success');
          form.current.reset();
        },
        () => {
          setStatus('error');
        }
      );
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-3xl font-bold mb-6">Contact Us</h2>
          <div className="space-y-4">
            <div className="flex items-center">
              <Phone className="text-[#0099FF] mr-4" />
              <p>+36 20 226 6679</p>
            </div>
            <div className="flex items-center">
              <Mail className="text-[#0099FF] mr-4" />
              <p>contact@ucorierkft.com</p>
            </div>
            <div className="flex items-center">
              <MapPin className="text-[#0099FF] mr-4" />
              <p>1146 Budapest, Thököly út 45. 1. lház. alagsor 1. ajtó</p>
            </div>
          </div>
        </div>
        <form ref={form} onSubmit={sendEmail} className="space-y-4">
          <input
            type="text"
            name="user_name" // Ensure this matches the template's {{user_name}}
            placeholder="Your Name"
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="email"
            name="user_email" // Ensure this matches the template's {{user_email}}
            placeholder="Your Email"
            className="w-full p-2 border rounded"
            required
          />
          <textarea
            name="message" // Ensure this matches the template's {{message}}
            placeholder="Your Message"
            className="w-full p-2 border rounded h-32"
            required
          />
          <button
            type="submit"
            className="bg-[#0099FF] text-white px-6 py-2 rounded disabled:opacity-50"
            disabled={status === 'sending'}
          >
            {status === 'sending' ? 'Sending...' : 'Send Message'}
          </button>

          {status === 'success' && (
            <div className="text-green-600">Message sent successfully!</div>
          )}
          {status === 'error' && (
            <div className="text-red-600">Failed to send message. Please try again.</div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;
